import 'moment-duration-format';
import { Moment } from 'moment';
import { MOMENT_UNIT } from '@core/utils/moment';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { getMomentFromDate } from '@core/utils/date-time';

/**
 * Validates the form value from string as after a min datetime.
 * @param {string} maxValue
 * @param {MOMENT_UNIT} granularity
 * @returns {ValidatorFn}
 */
export function minDatetime(maxValue: string, granularity?: MOMENT_UNIT): ValidatorFn {
    const maxMoment: Moment = getMomentFromDate(maxValue);
    return (control: AbstractControl): ValidationErrors | null => {
        const formItem: any = control;
        const formMoment: Moment = getMomentFromDate((formItem as FormControl).value);
        let isValid: boolean = false;

        if (formMoment && formMoment.isValid()) {
            isValid = formMoment.isAfter(maxMoment, granularity);
        }

        return isValid ? null : { maxDatetime: true };
    }
}
